import { Copy } from 'lucide-react';
import type { ReactNode } from 'react';

import PropertyValue from '@/components/Typography/PropertyValue';
import { cn } from '@/lib/cn';
import { toast } from '@/stores/pure/ToastStore';
import { clipboardCopy } from '@/utils/util';

import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const StringField = (
  props: CommonFieldProps & {
    value?: ReactNode;
    expandable?: boolean;
    icon: ReactNode;
    valueIcon?: ReactNode;
    placeholder?: string;
    useCopy?: boolean;
    suffix?: string;
  },
) => {
  if (!props.showFull && typeof props.value === 'undefined') return null;

  const handleCopy = () => {
    if (props.useCopy) {
      clipboardCopy(props.value as string);
      toast('Copied to clipboard', 'success');
    }
  };

  return (
    <PropertyRowWrapper
      {...props}
      expandable={props.expandable}
      className={cn('group', props.useCopy && 'cursor-pointer')}
    >
      <PropertyValue
        value={props.value}
        onClick={props.useCopy ? handleCopy : undefined}
        icon={props.valueIcon}
        placeholder={props.placeholder}
        isEllipsis
        suffix={props.suffix}
      />
      {props.useCopy && (
        <Copy
          className="size-4 text-gray-600 group-hover:opacity-100 opacity-0 transition-opacity duration-200"
          onClick={handleCopy}
        />
      )}
    </PropertyRowWrapper>
  );
};
